var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonLogoFitgenie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "common_logo_fitgenie_svg__a",
    d: "M.012.168h93.93v27.82H.012z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "common_logo_fitgenie_svg__c",
    d: "M.103.04h100.786v31.948H.103z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "common_logo_fitgenie_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#common_logo_fitgenie_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#131A14",
    d: "M3.654 3.874v8.762h11.668v3.397H3.654v11.465H0V.477h17.06v3.397H3.654m17 23.624h3.418v-19.3h-3.418v19.3zm-.589-25.053c0-1.235 1.021-2.277 2.318-2.277a2.293 2.293 0 012.279 2.277c0 1.236-1.022 2.24-2.279 2.24-1.297 0-2.318-1.004-2.318-2.24zm14.418 8.995V21.9c0 2.934 1.729 2.74 5.225 2.586v3.011c-5.893.772-8.643-.772-8.643-5.597V11.44h-3.89V8.332h2.793c.606 0 1.097-.483 1.097-1.078V3.797l3.418-1.004v5.404h5.225v3.243h-5.225m42.88 5.018h13.122c-.59-3.822-3.379-5.597-6.325-5.597-3.693 0-6.247 2.239-6.797 5.597zm7.111 8.377c2.71 0 4.675-1.236 5.657-2.818l2.908 1.621C91.31 26.263 88.324 28 84.396 28c-6.326 0-10.53-4.362-10.53-10.152 0-5.713 4.165-10.153 10.294-10.153 5.932 0 9.782 4.787 9.782 10.191a9.72 9.72 0 01-.118 1.506h-16.46c.667 3.474 3.456 5.443 7.11 5.443z",
    mask: "url(#common_logo_fitgenie_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#131A14",
    d: "M114 19.031V31h-3.339V19.226c0-3.197-1.803-4.99-4.758-4.99-3.07 0-5.565 1.832-5.565 6.433V31H97V11.507h3.338v2.807c1.42-2.3 3.531-3.314 6.217-3.314 4.49 0 7.445 3.041 7.445 8.031"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "common_logo_fitgenie_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#common_logo_fitgenie_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#131A14",
    d: "M74.59 31.49h3.406V11.883H74.59V31.49zm-.588-25.45a2.316 2.316 0 012.31-2.314c1.253 0 2.272 1.059 2.272 2.314a2.275 2.275 0 01-2.272 2.274c-1.292 0-2.31-1.02-2.31-2.274zm10.361 14.235h13.08c-.588-3.883-3.368-5.686-6.305-5.686-3.681 0-6.227 2.274-6.775 5.686zm7.088 8.51c2.702 0 4.66-1.256 5.64-2.863l2.897 1.647C98.265 30.235 95.29 32 91.373 32c-6.305 0-10.496-4.431-10.496-10.313 0-5.804 4.151-10.314 10.26-10.314 5.914 0 9.752 4.863 9.752 10.353 0 .51-.04 1.02-.117 1.53h-16.41c.666 3.529 3.447 5.529 7.09 5.529z",
    mask: "url(#common_logo_fitgenie_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15A359",
    d: "M24.387 13.935a12.123 12.123 0 00-6.938-6.948A12.122 12.122 0 0024.387.04a12.122 12.122 0 006.939 6.947 12.123 12.123 0 00-6.939 6.948",
    mask: "url(#common_logo_fitgenie_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131A14",
    d: "M28.542 17.41h-14.62v3.474h10.696c-1.342 4.418-5.447 7.642-10.291 7.642-5.93 0-10.755-4.831-10.755-10.769 0-5.822 4.638-10.576 10.408-10.76V3.523C6.297 3.708.103 10.02.103 17.757.103 25.61 6.483 32 14.327 32c7.843 0 14.224-6.39 14.224-14.243 0-.117-.006-.231-.009-.347",
    mask: "url(#common_logo_fitgenie_svg__d)"
  })))));
}

export default SvgCommonLogoFitgenie;